import { inject } from '@angular/core';

import { ClusterService } from '../../../core/services';
import type { NfDatasourceRegistry } from '../nf-datasource.service';

/**
 * Coulson backend — base URL follows the active cluster (Production/Staging/Development)
 * selected in the topbar/sidebar, via ClusterService.coulsonBaseUrl().
 *
 * Any toolbelt schema referencing `x-datasource.service: 'coulson'` and a `path` under
 * `x-datasource.endpoints.*` resolves through this entry: NfDatasourceService joins this
 * base URL with that path at request time.
 */
export const coulsonDatasource: NfDatasourceRegistry = {
  coulson: () => inject(ClusterService).coulsonBaseUrl(),
};
